import { useState } from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import QuoteSection from '../components/QuoteSection';
import LightboxModal from '../components/LightboxModal';
import { companyInfo } from '../data/siteData';
import { imageUrl } from '../lib/images';

export default function PanellaagePage() {
  const [lightboxIndex, setLightboxIndex] = useState(null);

  const images = [
    { src: "/_assets/pxl-20260626-182849918-mp.jpg", title: "Galvaniseret dobbelt panellåge på indkørsel" },
    { src: "/_assets/pxl-20260531-083803960.jpg", title: "Sort panellåge monteret ved murstensvæg" },
    { src: "/_assets/pxl-20260531-083822023.jpg", title: "Sort panellåge og panelhegn ved terrasse" },
    { src: "/_assets/img20251224093853.jpg", title: "Galvaniseret gitterlåge ved depotrum" },
    { src: "/_assets/333571161-1143977852939452-4405149958717881853-n-2.jpg", title: "Panellåge" },
    { src: "/_assets/thumbnail-1000003507.jpg", title: "Panellåge i hegn" },
    { src: "/_assets/thumbnail-1000003516.jpg", title: "Panellåge med lås" },
    { src: "/_assets/thumbnail-img20240508122959.jpg", title: "Panellåge montering" },
    { src: "/_assets/thumbnail-img20250430120431.jpg", title: "Dobbelt panellåge" },
  ];

  return (
    <>
      <SEO
        title="Panellåger til alle formål | Hovendals"
        description="Panellåger til have og erhverv Panellåge er et kraftigt trådhegn, som kan anvendes til mange forskellige løsninger. Det kan blandt andet bruges til haver, vareindlevering, skoler og fodboldbaner. Hos Hovendals har vi mange års erfaring med panellåger, og skal uden tvivl hjælpe dig med at få den løsning, som du ønsker. Få et uforpligtende tilbud her"
        ogImage="/_assets/472206536-1118964739603980-7349353629794315307-n.jpg"
      />

      {/* Hero */}
      <section className="relative py-20 bg-slate-900 text-white overflow-hidden">
        <div className="absolute inset-0 z-0 opacity-25">
          <img
            src={imageUrl("/_assets/472206536-1118964739603980-7349353629794315307-n.jpg", "width=1600,quality=80,format=auto")}
            alt="Panellåger"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="max-w-3xl space-y-4">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider bg-[#004fa4]/20 text-[#c2ccdf] border border-[#004fa4]/30">
              <i className="fa-sharp fa-solid fa-shield-check" aria-hidden="true"></i>
              <span>Have og erhverv</span>
            </div>
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-white leading-tight">
              Panellåger til alle formål
            </h1>
            <p className="text-base sm:text-lg text-slate-300 leading-relaxed font-normal">
              Solid, funktionel og økonomisk løsning til sikker afgrænsning af både private og erhvervsmæssige ejendomme.
            </p>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16 md:py-20 bg-white">
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
            <div className="space-y-6">
              <div>
                <span className="text-xs font-bold uppercase tracking-wider text-[#004fa4]">Alsidig anvendelse</span>
                <h2 className="text-2xl sm:text-3xl font-extrabold text-slate-900 tracking-tight mt-1">
                  Panellåger til have og erhverv
                </h2>
              </div>
              <p className="text-slate-700 leading-relaxed text-base">
                Panellåge er et kraftigt trådhegn, som kan anvendes til mange forskellige løsninger. Det kan blandt andet bruges til haver, vareindlevering, skoler og fodboldbaner. Hos Hovendals har vi mange års erfaring med panellåger, og skal uden tvivl hjælpe dig med at få den løsning, som du ønsker.
              </p>

              <div>
                <h3 className="text-xl font-bold text-slate-900 mb-2">
                  Hvorfor vælge en panellåge?
                </h3>
                <p className="text-slate-700 leading-relaxed text-base mb-3">
                  Panellåge er en yderst funktionel og økonomisk løsning til afgrænsning af både private og erhvervsmæssige ejendomme. Disse låger er karakteriseret ved deres simple og rene linjer, hvilket gør dem både nemme at installere og vedligeholde. Panellåge en solid og holdbar barriere, der effektivt kan sikre privatliv, sikkerhed og tydelige afgrænsninger.
                </p>
                <p className="text-slate-700 leading-relaxed text-base">
                  De er tilgængelige i en række højder og stilarter, hvilket giver mulighed for tilpasning til specifikke behov og æstetiske præferencer. Med deres alsidighed og gode pris er panellåger en populær valgmulighed for mange, der søger en praktisk løsning til at definere grænser uden at gå på kompromis med udseendet.
                </p>
              </div>

              <div className="flex flex-wrap gap-4 pt-2">
                <a
                  href={`tel:${companyInfo.phoneFormatted}`}
                  className="px-6 py-3 rounded-lg bg-[#004fa4] hover:bg-[#183e7f] text-white font-medium text-sm shadow-sm transition-all flex items-center gap-2"
                >
                  <i className="fa-sharp fa-solid fa-phone" aria-hidden="true"></i>
                  <span>Ring: {companyInfo.phone}</span>
                </a>
                <Link
                  to="/kontakt"
                  className="px-6 py-3 rounded-lg bg-slate-900 hover:bg-slate-800 text-white font-bold text-sm transition-all flex items-center gap-2"
                >
                  <i className="fa-sharp fa-solid fa-paper-plane" aria-hidden="true"></i>
                  <span>Få et uforpligtende tilbud her</span>
                </Link>
              </div>
            </div>

            <div className="relative rounded-2xl overflow-hidden shadow-xl border-4 border-white bg-slate-100">
              <img
                src={imageUrl("/_assets/333571161-1143977852939452-4405149958717881853-n-2.jpg", "width=800,quality=85,format=auto")}
                alt="Panellåge"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>

          {/* Galleri */}
          <div className="mb-16">
            <h3 className="text-2xl font-bold text-slate-900 mb-2">
              Panellåger galleri
            </h3>
            <p className="text-sm text-slate-600 mb-6">
              Klik på et billede for at se eksempler på vores monterede panellåger.
            </p>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3">
              {images.map((img, idx) => (
                <div
                  key={idx}
                  onClick={() => setLightboxIndex(idx)}
                  className="group relative h-48 rounded-xl overflow-hidden bg-slate-100 cursor-pointer shadow-sm hover:shadow-md transition-all"
                >
                  <img
                    src={imageUrl(img.src, "width=400,quality=80,format=auto")}
                    alt={img.title}
                    className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-slate-950/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center text-white">
                    <span className="p-2 rounded-full bg-[#143463]/90 text-white text-xs">
                      <i className="fa-sharp fa-solid fa-magnifying-glass-plus" aria-hidden="true"></i>
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Kontakt boks */}
          <div className="bg-slate-50 rounded-2xl p-8 sm:p-10 border border-slate-200/80 space-y-4">
            <h3 className="text-2xl font-bold text-slate-900">
              Kontakt os og få et uforpligtende tilbud
            </h3>
            <p className="text-slate-700 leading-relaxed text-base">
              Ønsker du at få et uforpligtende tilbud på panellåge? Så er du velkommen til at kontakte os på <a href={`tel:${companyInfo.phoneFormatted}`} className="text-[#004fa4] font-bold hover:underline">{companyInfo.phone}</a> eller send os en mail på <a href={`mailto:${companyInfo.email}`} className="text-[#004fa4] font-bold hover:underline">{companyInfo.email}</a> også vender vi tilbage til dig hurtigst muligt.
            </p>
          </div>
        </div>
      </section>

      {/* Quote Section */}
      <QuoteSection />

      {/* Lightbox modal */}
      <LightboxModal
        images={images}
        currentIndex={lightboxIndex}
        onClose={() => setLightboxIndex(null)}
        onNavigate={(index) => setLightboxIndex(index)}
      />
    </>
  );
}
